/**
 *  @author:        Cloud for Good
 *  @description:   Reusable function for resizing image carousels
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2022-09-30    Cloud for Good       N/A                Initial creation
 *  2025-03-03    Jassin Yacks         CFG-761            Added PDP recommended product carousel
*/

'use strict';

/**
 *  Normalize carousel height to the tallest of carousel items to prevent jumping on page
 */

function normalizeCarouselHeight(items, carouselInner) {

    var carouselItems = $(items);
    var heights = []; // array to store heights
    var tallest; // tallest slide
    if (carouselItems.length) {
        carouselItems.each(function() {
            heights.push($(this).height());
        });

        // get the tallest height
        tallest = Math.max.apply(null, heights);
        // add some padding
        tallest += 15;

        // set each item to the tallest height
        carouselItems.each(function() {
            $(this).css('height', tallest + 'px');
        });

        // set carousel inner row to tallest height
        $(carouselInner).css('height', tallest + 'px');
    };

    $('#pdpRecommendCarousel.carousel .carousel-item').each(function(){
        var minPerSlide = 3;
        var next = $(this).next();
        if (!next.length) {
        next = $(this).siblings(':first');
        }
        next.children(':first-child').clone().appendTo($(this));
        
        for (var i=0;i<minPerSlide;i++) {
            next=next.next();
            if (!next.length) {
                next = $(this).siblings(':first');
              }
            
            next.children(':first-child').clone().appendTo($(this));
        }
    });
}

module.exports = {
    normalizeCarouselHeight: normalizeCarouselHeight
};